import { CountryCode } from '@advanza/func'
import { createReducer } from '@reduxjs/toolkit'
import Cookie from 'js-cookie'

type State = {
    countries: CountryCode[]
}

const initialState: State = {
    countries: [(Cookie.get('_trustoo_office_country') as CountryCode | undefined) || 'NL'],
}

type ChangeCountryAction = {
    type: 'CHANGE_COUNTRY'
    countries: CountryCode[]
}

export default createReducer(initialState, (builder) => {
    return builder.addCase('CHANGE_COUNTRY', (state, action: ChangeCountryAction) => {
        return { ...state, countries: action.countries }
    })
})
